import React, { useState, useRef } from "react";
import { Card, CardBody, Col, Container, Icon, Row, Button, Alert } from "design-react-kit";
import { useLocation, useNavigate } from "react-router-dom";
import Cropper from "react-cropper";
import "../../../style/css/cropper.css";
import { properties } from "../../../config/properties";

const styles = {
    card: {
        padding: '2rem',
        borderRadius: '12px',
        backgroundColor: '#fefefe',
        boxShadow: '0 8px 24px rgba(0, 0, 0, 0.12)',
        border: '1px solid #ddd',
        transition: 'transform 0.2s ease-in-out',
    },
    cardBody: { padding: "2rem" },
    sectionTitle: {
        fontSize: '1.1rem',
        fontWeight: '700',
        color: '#0b5ed7',
        borderBottom: '2px solid #0b5ed7',
        paddingBottom: '0.25rem',
        marginBottom: '1rem',
        textTransform: 'uppercase',
        letterSpacing: '0.5px',
    },
    titleIcon: { marginRight: "0.75rem" },
    fieldLabel: { fontWeight: '500', color: '#6c757d', marginBottom: '0.25rem', fontSize: '0.9rem' },
    fieldValue: { marginBottom: '1rem', fontWeight: '600', fontSize: '1rem', color: '#212529' },
    firmaContainer: { textAlign: "center", padding: "1rem" },
    firmaImage: {


        maxWidth: '100%',
        width: 'auto',
        height: '150px',
        minHeight: '150px',
        maxHeight: '150px',
        objectFit: 'contain',
        border: '1px solid #dee2e6',
        borderRadius: '6px',
        backgroundColor: '#f8f9fa',
        padding: '0.5rem',
        display: 'block',
    },
    firmaPlaceholder: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: '120px',
        backgroundColor: '#f8f9fa',
        border: '1px dashed #ced4da',
        borderRadius: '6px',
        color: '#6c757d',
        fontStyle: 'italic',
        fontSize: '0.9rem',
    },
};

const GestioneFirma = ({ user }) => {
    const location = useLocation();
    const navigate = useNavigate();
    const { nomeProfilo, cognomeProfilo, firmaProfilo, firmaSiglaProfilo, firmaData, idProfilo, statoFirma } = location.state || {};

    const [imageSrc, setImageSrc] = useState(null);
    const [fase, setFase] = useState("firma");
    const [firmaCropped, setFirmaCropped] = useState(null);
    const [siglaCropped, setSiglaCropped] = useState(null);
    const [dataDeposito, setDataDeposito] = useState(() => {
        const today = new Date();
        return today.toISOString().split('T')[0]; // YYYY-MM-DD
    });
    const [alert, setAlert] = useState({ visible: false, type: '', message: '' });

    const cropperRef = useRef(null);
    const fileInputRef = useRef(null);

    const handleFileChange = (e) => {
        const MAX_FILE_SIZE_MB = 2;
        const MAX_FILE_SIZE = MAX_FILE_SIZE_MB * 1024 * 1024;
        setAlert({ visible: false, type: 'warning', message: '' });
        const file = e.target.files[0];

        if (file && file.type === "image/jpeg") {
            if (file.size > MAX_FILE_SIZE) {
                window.scrollTo({ top: 0, behavior: 'smooth' });
                setAlert({ visible: true, type: 'warning', message: 'File troppo grande, massimo 2MB' });
                fileInputRef.current.value = null;
                setImageSrc(null);
                setFirmaCropped(null);
                setSiglaCropped(null);
                return;
            }

            const reader = new FileReader();
            reader.onload = () => {
                setImageSrc(reader.result);
                setFase("firma");
                setFirmaCropped(null);
                setSiglaCropped(null);
            };
            reader.readAsDataURL(file);
        } else {
            window.scrollTo({ top: 0, behavior: 'smooth' });
            setAlert({ visible: true, type: 'danger', message: "Inserire un'immagine in formato JPG" });
            fileInputRef.current.value = null;
            setImageSrc(null);
            setFirmaCropped(null);
            setSiglaCropped(null);
        }
    };



    /*
    const handleCropConfirm = async () => {
        if (!cropperRef.current) return;

        const cropper = cropperRef.current.cropper;
        const croppedBase64 = cropper.getCroppedCanvas().toDataURL("image/jpeg");

        if (fase === "firma") {
            setFirmaCropped(croppedBase64);
            setFase("sigla");
        } else if (fase === "sigla") {
            setSiglaCropped(croppedBase64);
        }
    };
     */
    const handleCropConfirm = async () => {
        if (!cropperRef.current) return;

        const cropper = cropperRef.current.cropper;

        // Genera il base64. Nota: puoi passare un secondo parametro (es. 0.8) per la qualità JPEG se vuoi comprimerla nativamente
        const croppedBase64 = cropper.getCroppedCanvas().toDataURL("image/jpeg");

        // 1. Separa l'intestazione ("data:image/jpeg;base64,") dal contenuto effettivo
        const base64Data = croppedBase64.split(',')[1];

        // 2. Calcola la dimensione in byte decodificando la stringa
        const sizeInBytes = window.atob(base64Data).length;
        const MAX_CROP_SIZE = 64 * 1024; // 64 KB in byte

        // 3. Controllo della dimensione
        if (sizeInBytes > MAX_CROP_SIZE) {
            window.scrollTo({ top: 0, behavior: 'smooth' });
            setAlert({
                visible: true,
                type: 'warning',
                message: `L'area selezionata per la ${fase === "firma" ? "firma per esteso" : "sigla"} è troppo grande (${(sizeInBytes / 1024).toFixed(1)} KB). Il massimo consentito è 64 KB. Prova a rimpicciolire il ritaglio.`
            });
            return; // Blocca il salvataggio del ritaglio
        }

        // Se il controllo passa, nascondiamo eventuali alert precedenti
        setAlert({ visible: false, type: 'warning', message: '' });


        // 4. Logica originale inalterata
        if (fase === "firma") {
            setFirmaCropped(croppedBase64);
            setFase("sigla");
        } else if (fase === "sigla") {
            setSiglaCropped(croppedBase64);
        }
    };
    const addNewFirma = async () => {
        const data = {
            firma: firmaCropped.split(',')[1],
            siglaFirma: siglaCropped.split(',')[1],
            dataFirma: dataDeposito,
            idPersona: idProfilo,
            userID: user.userID,
            cciaa: user.cciaa,
            gruppoUtente: user.gruppoUtente
        };

        const datiRicerca = { dati: { id: idProfilo } };

        try {
            const response = await fetch(
                `${properties.fullBaseUrl}${properties.baseAppUrl}/std/service/add/firma`,
                {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify(data)
                }
            );

            if (response.status === 401) {
                const datasResponse = await response.json();
                setAlert({ visible: true, type: 'danger', message: 'Errore di comunicazione con il server.' });
                window.scrollTo({ top: 0, behavior: 'smooth' });
                setTimeout(() => { window.location.href = datasResponse.redirectUrl; }, 10);
                return;
            }

            const json = await response.json();
            navigate('/private/profiloPersona', { state: { esito: json, ricerca: datiRicerca, idProfilo, nomeProfilo, cognomeProfilo } });
        } catch (error) {
            const json = { esito: "KO", messaggio: "Errore del server." };
            navigate('/private/profiloPersona', { state: { esito: json, ricerca: datiRicerca, idProfilo, nomeProfilo, cognomeProfilo } });
        }
    };

    return (
        <Container>
            <div className={"pt-4"}>
                <h2>Firma per {nomeProfilo} {cognomeProfilo}</h2>
            </div>

            {alert.visible && (
                <Alert color={alert.type} isOpen={alert.visible} toggle={() => setAlert({ ...alert, visible: false })}>
                    {alert.message}
                </Alert>
            )}

            {/* Card Firma esistente */}
            <Card style={styles.card} className="mb-4 shadow-bg border-0 p-3 card-hover">
                <CardBody style={styles.cardBody} className="d-flex flex-column">
                    <h2 style={styles.sectionTitle}>
                        <Icon icon="it-pencil" size="sm" style={styles.titleIcon} />
                        Firma attualmente depositata
                    </h2>
                    <Row>
                        <Col md={7} style={styles.firmaContainer}>
                            <p style={{ ...styles.fieldValue, fontSize: "large" }}>Firma per esteso</p>
                            <FirmaComponent base64String={firmaProfilo} label="firma" />
                        </Col>
                        <Col md={5} style={styles.firmaContainer}>
                            <p style={{...styles.fieldValue, fontSize: "large"}}>Firma abbreviata</p>
                            <div style={{display: "flex", justifyContent: "center"}}>
                                <FirmaComponent base64String={firmaSiglaProfilo} label="sigla"/>
                            </div>

                        </Col>
                    </Row>

                    <div className="d-flex justify-content-between align-items-start">
                        <div>
                            <p style={{...styles.fieldValue, fontSize: "large"}}>Firma depositata
                                il: {firmaData || "-"}</p>
                        </div>
                        <span style={{ color: statoFirma === 'PUBBLICATA' ? 'green' : 'red' }} className="text-uppercase">
                            {statoFirma}
                        </span>
                    </div>
                </CardBody>
            </Card>

            {/* Card Nuova Firma */}
            <Card style={styles.card} className="mb-4 shadow-bg border-0 p-3 card-hover">
                <CardBody style={styles.cardBody} className="d-flex flex-column">
                    <h2 style={styles.sectionTitle}>
                        <Icon icon="it-pencil" size="sm" style={styles.titleIcon} />
                        Inserisci nuova Firma
                    </h2>

                    <input type="file" ref={fileInputRef} accept="image/jpeg" onChange={handleFileChange} style={{ marginBottom: "1rem" }} />

                    {imageSrc && (!firmaCropped || !siglaCropped) && (
                        <>
                            <Cropper
                                src={imageSrc}
                                style={{ height: 400, width: "100%" }}
                                // aspectRatio facoltativo, per firma puoi rimuovere per crop libero
                                guides={true}
                                viewMode={1}
                                dragMode="move"
                                responsive={true}
                                checkOrientation={true}
                                ref={cropperRef}
                                autoCropArea={0.8}
                            />
                            <Button className="btn btn-outline-primary mt-2" onClick={handleCropConfirm}>
                                Conferma selezione {fase === "firma" ? "firma per esteso" : "sigla"}
                            </Button>
                        </>
                    )}

                    <Row>
                        <Col md={8}>
                            {firmaCropped && (
                                <div style={styles.firmaContainer}>
                                    <p style={styles.fieldLabel}>Firma per esteso selezionata</p>
                                    <img src={firmaCropped} alt="firma" style={styles.firmaImage} />
                                </div>
                            )}
                        </Col>

                        <Col md={4}>
                            {siglaCropped && (
                                <div style={styles.firmaContainer}>
                                    <p style={styles.fieldLabel}>Sigla selezionata</p>
                                    <img src={siglaCropped} alt="sigla" style={styles.firmaImage} />
                                </div>
                            )}
                        </Col>
                    </Row>

                    <Row className={"mt-3"}>
                        <Col md={2}>
                            {firmaCropped && siglaCropped && (
                                <div>
                                    <label style={styles.fieldLabel}>Data Deposito della firma</label>
                                    <input type="date" className="form-control" value={dataDeposito || ''} onChange={(e) => setDataDeposito(e.target.value)} required />
                                </div>
                            )}
                        </Col>
                        <Col md={10}>
                            {firmaCropped && siglaCropped && dataDeposito && (
                                <div className={"mt-3"}>
                                    <Button className="btn btn-outline-primary" onClick={addNewFirma}>
                                        Conferma aggiornamento firma
                                    </Button>
                                </div>
                            )}
                        </Col>
                    </Row>
                </CardBody>
            </Card>
        </Container>
    );
};

function FirmaComponent({ base64String, label }) {
    if (!base64String) {
        return (
            <div style={styles.firmaPlaceholder}>
                <span>Nessuna {label}</span>
            </div>
        );
    }
    const imgSrc = base64String.startsWith("data:image") ? base64String : `data:image/png;base64,${base64String}`;
    return <img src={imgSrc} alt={label} style={styles.firmaImage} />;
}

export default GestioneFirma;
